const styles = theme => {
  return {
    root: { backgroundColor: '#FAFAFA', width: '100%' },
    content: {
      display: 'flex',
      overflow: 'visible',
      justifyContent: 'space-between',
      minHeight: '400px',
      [theme.breakpoints.down(theme.breakpoints.values.md - 100)]: {
        flexDirection: 'column'
      }
    },
    label: {
      paddingTop: '10px',
      fontSize: '14px',
      fontWeight: 500,
      marginBottom: '20px'
    },
    boxLabel: { paddingLeft: '30px', fontWeight: '600' },
    box: { padding: '5px 0' }
  };
};

export default styles;

export const checkboxCustomStyles = {
  root: { width: '320px' }
};
